export function toAzureDevOpsStateKey(
    state: string | null | undefined,
): string {
    if (!state) return 'unknown';
    return state.trim().toLowerCase().replace(/\s+/g, '_'); // "Next up" -> "next_up"
}
